import { FC, ReactNode } from 'react';
import Nyhetslista, { Nyheter } from '../../components/Nyhetslista/Nyhetslista';
import PageInfo from '../../components/PageInfo/PageInfo';
import styles from './Nyhetsarkiv.module.css';
import { ContentResponse } from '../../types/shared';

interface INyheterProps {
  contentResponse: ContentResponse;
}

const Nyhetsarkiv: FC<INyheterProps> = ({ contentResponse }): ReactNode => {
  const nyheter = contentResponse.content as Nyheter;

  return (
    <div className={styles.container}>
      <PageInfo variant="breadcrumbs" contentResponse={contentResponse}></PageInfo>
      <Nyhetslista nyhetslista={nyheter}></Nyhetslista>
    </div>
  );
};

export default Nyhetsarkiv;
